// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-Tabs-___TabsRouter-module__container {
  background-color: #fff;
  height: 100%;
}

.app-components-Tabs-___TabsRouter-module__nav {
  text-transform: uppercase;
  border-bottom: 2px solid #979797;
  color: var(--colors-blackLight);
  font-family: 'ralewaybold';
  max-height: 35px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.app-components-Tabs-___TabsRouter-module__navItem {
  line-height: 2.5;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  color: var(--colors-black);
  background-color: #f3f3f3;
  margin: 0px 2px;
  display: flex;
  height: 100%;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.app-components-Tabs-___TabsRouter-module__navSubItemWrapper {
  position: absolute;
  z-index: 100;
  margin-left: 50%;
}
.app-components-Tabs-___TabsRouter-module__navSubItemContainer {
  position: relative;
  z-index: 100;
  display: none;
  flex-direction: column;
  flex-wrap: nowrap;
  margin-left: -50%;
  padding-top: 2px;
  width: -moz-fit-content;
  width: fit-content;
  box-shadow: -2px 3px 15px -6px #000000;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
.app-components-Tabs-___TabsRouter-module__navSubItemContainer:hover,
.app-components-Tabs-___TabsRouter-module__navItem:hover ~ .app-components-Tabs-___TabsRouter-module__navSubItemWrapper > .app-components-Tabs-___TabsRouter-module__navSubItemContainer {
  display: flex;
}

.app-components-Tabs-___TabsRouter-module__navSubItemContainer > div:last-child > a {
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}

.app-components-Tabs-___TabsRouter-module__navSubItem {
  line-height: 2.5;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--colors-black);
  background-color: #f3f3f3;
  padding: 0px 30px;
  display: flex;
  height: 100%;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.app-components-Tabs-___TabsRouter-module__navSubItem.app-components-Tabs-___TabsRouter-module__active,
.app-components-Tabs-___TabsRouter-module__navItem.app-components-Tabs-___TabsRouter-module__active {
  color: #fff;
  background-color: #979797;
}

.app-components-Tabs-___TabsRouter-module__navSubItem:not(.app-components-Tabs-___TabsRouter-module__active):hover,
.app-components-Tabs-___TabsRouter-module__navItem:not(.app-components-Tabs-___TabsRouter-module__active):hover {
  background-color: #e5e5e5;
  color: var(--colors-black);
  cursor: pointer;
}

.app-components-Tabs-___TabsRouter-module__childrenContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  border-left: var(--mainBorder);
  border-right: var(--mainBorder);
  border-bottom: var(--mainBorder);
  height: calc(100% - 35px);
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./app/components/Tabs/TabsRouter.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;EAClB,sCAAsC;EACtC,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,yBAAyB;EACzB,WAAW;AACb","sourcesContent":[".container {\n  background-color: #fff;\n  height: 100%;\n}\n\n.nav {\n  text-transform: uppercase;\n  border-bottom: 2px solid #979797;\n  color: var(--colors-blackLight);\n  font-family: 'ralewaybold';\n  max-height: 35px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.navItem {\n  line-height: 2.5;\n  text-align: center;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  color: var(--colors-black);\n  background-color: #f3f3f3;\n  margin: 0px 2px;\n  display: flex;\n  height: 100%;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n}\n\n.navSubItemWrapper {\n  position: absolute;\n  z-index: 100;\n  margin-left: 50%;\n}\n.navSubItemContainer {\n  position: relative;\n  z-index: 100;\n  display: none;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  margin-left: -50%;\n  padding-top: 2px;\n  width: fit-content;\n  box-shadow: -2px 3px 15px -6px #000000;\n  border-bottom-right-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n.navSubItemContainer:hover,\n.navItem:hover ~ .navSubItemWrapper > .navSubItemContainer {\n  display: flex;\n}\n\n.navSubItemContainer > div:last-child > a {\n  border-bottom-right-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n\n.navSubItem {\n  line-height: 2.5;\n  text-align: center;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: var(--colors-black);\n  background-color: #f3f3f3;\n  padding: 0px 30px;\n  display: flex;\n  height: 100%;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n}\n\n.navSubItem.active,\n.navItem.active {\n  color: #fff;\n  background-color: #979797;\n}\n\n.navSubItem:not(.active):hover,\n.navItem:not(.active):hover {\n  background-color: #e5e5e5;\n  color: var(--colors-black);\n  cursor: pointer;\n}\n\n.childrenContainer {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  border-left: var(--mainBorder);\n  border-right: var(--mainBorder);\n  border-bottom: var(--mainBorder);\n  height: calc(100% - 35px);\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-components-Tabs-___TabsRouter-module__container`,
	"nav": `app-components-Tabs-___TabsRouter-module__nav`,
	"navItem": `app-components-Tabs-___TabsRouter-module__navItem`,
	"navSubItemWrapper": `app-components-Tabs-___TabsRouter-module__navSubItemWrapper`,
	"navSubItemContainer": `app-components-Tabs-___TabsRouter-module__navSubItemContainer`,
	"navSubItem": `app-components-Tabs-___TabsRouter-module__navSubItem`,
	"active": `app-components-Tabs-___TabsRouter-module__active`,
	"childrenContainer": `app-components-Tabs-___TabsRouter-module__childrenContainer`
};
export default ___CSS_LOADER_EXPORT___;
